import { uploadExportRequestToServer } from "../../etsFunctions/etsFunctions";
import { ExportState } from "../../models/ProjectMetadata";
import universalstorageHandler from "../../persistence/UniversalstorageHandler";
import { itx } from "../../translationItx/itx";
import { showToast } from "../Toasts";

export async function uploadProjectForConversion(projectId?: string) {
  showToast({
    text: itx(
      "export.exportInProgressText", // no itx
      "Export läuft – dies kann eine Weile dauern. Sie können währenddessen weiterarbeiten.", // no itx
    ),
  });

  // if no project id given use actuall project (use inside of project)
  if (projectId) {
    await universalstorageHandler.loadProject(projectId);
  }
  await uploadExportRequestToServer();

  // set exportState inside metadata and save matadata on server
  state.projectMetadata.exportState = ExportState.WaitingForConversion;
  state.projectMetadata.uploadedToServerForConversion = new Date();
  state.projectMetadata.raiseOnChange("exportState");

  await universalstorageHandler.saveProjectMetaData(state.projectMetadata);
}
